<template>
  <div class="page-container">
    <Sidebar />
    
    <div class="main-content">
      <div class="page-header">
        <h1>建议反馈管理</h1>
      </div>
      
      <div class="filter-bar">
        <button
          :class="['filter-btn', currentStatus === '' ? 'active' : '']"
          @click="setFilter('')"
        >
          全部
        </button>
        <button
          :class="['filter-btn', currentStatus === 'pending' ? 'active' : '']"
          @click="setFilter('pending')"
        >
          待处理
        </button>
        <button
          :class="['filter-btn', currentStatus === 'processed' ? 'active' : '']"
          @click="setFilter('processed')"
        >
          已处理
        </button>
      </div>
      
      <div class="content-body">
        <div class="loading" v-if="loading">加载中...</div>
        <div class="error" v-else-if="error">{{ error }}</div>
        
        <table class="suggestions-table" v-else>
          <thead>
            <tr>
              <th>ID</th>
              <th>用户</th>
              <th>建议内容</th>
              <th>链接</th>
              <th>状态</th>
              <th>提交时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in suggestions" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.display_name || item.company_name || item.phone || '匿名用户' }}</td>
              <td class="content-cell">{{ item.content }}</td>
              <td>
                <a v-if="item.link" :href="item.link" target="_blank" class="link-btn">查看</a>
                <span v-else>-</span>
              </td>
              <td>
                <StatusTag :status="item.is_read ? 'processed' : 'pending'" :custom-map="{ pending: '待处理', processed: '已处理' }" />
              </td>
              <td>{{ formatDate(item.created_at) }}</td>
              <td class="actions">
                <button 
                  v-if="!item.is_read"
                  class="process-btn" 
                  @click="markAsRead(item.id)"
                >
                  标记已处理
                </button>
                <span v-else class="done-text">已完成</span>
              </td>
            </tr>
            <tr v-if="suggestions.length === 0">
              <td colspan="7" class="empty">暂无建议反馈</td>
            </tr>
          </tbody>
        </table>
        
        <div class="pagination" v-if="totalPages > 1">
          <button :disabled="currentPage === 1" @click="changePage(currentPage - 1)">上一页</button>
          <span>{{ currentPage }} / {{ totalPages }}</span>
          <button :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">下一页</button>
        </div>
        
        <div class="total" v-if="!loading && !error">共 {{ total }} 条记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import StatusTag from '../components/StatusTag.vue'
import axios from 'axios'
import { formatDate } from '../utils/dateFormat'
import { getAdminPassword } from '../utils/api'

export default {
  name: 'SuggestionsList',
  components: { Sidebar, StatusTag },
  data() {
    return {
      suggestions: [],
      loading: true,
      error: '',
      currentStatus: '',
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  mounted() {
    this.fetchSuggestions()
  },
  methods: {
    async fetchSuggestions() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          status: this.currentStatus || undefined
        }
        const response = await axios.get('/api/admin/suggestions', {
          params,
          headers: { 'x-admin-password': getAdminPassword() }
        })
        if (response.data.code === 200) {
          const data = response.data.data
          this.suggestions = data.list || []
          this.total = data.total || 0
        } else {
          this.error = response.data.msg
        }
      } catch (err) {
        this.error = '获取数据失败'
      } finally {
        this.loading = false
      }
    },
    setFilter(status) {
      this.currentStatus = status
      this.currentPage = 1
      this.fetchSuggestions()
    },
    changePage(page) {
      this.currentPage = page
      this.fetchSuggestions()
    },
    formatDate(dateStr) {
      return formatDate(dateStr)
    },
    async markAsRead(id) {
      if (!confirm('确定标记为已处理？')) return
      try {
        const response = await axios.put(
          `/api/admin/suggestions/${id}/read`,
          {},
          { headers: { 'x-admin-password': getAdminPassword() } }
        )
        if (response.data.code === 200) {
          this.fetchSuggestions()
        } else {
          alert(response.data.msg)
        }
      } catch (err) {
        alert('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
.page-header { margin-bottom: 20px; }
.page-header h1 { font-size: 24px; color: #2c3e50; }
.filter-bar { display: flex; gap: 10px; margin-bottom: 20px; }
.filter-btn { padding: 8px 20px; background: white; border: 1px solid #ddd; border-radius: 5px; cursor: pointer; }
.filter-btn.active { background: #3498db; color: white; border-color: #3498db; }
.content-body { background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
.loading, .error, .empty { text-align: center; padding: 50px; color: #666; }
.error { color: #e74c3c; }
.suggestions-table { width: 100%; border-collapse: collapse; }
.suggestions-table th { background: #f8f9fa; padding: 15px; text-align: left; font-weight: 600; color: #333; border-bottom: 2px solid #eee; }
.suggestions-table td { padding: 15px; border-bottom: 1px solid #eee; color: #666; }
.suggestions-table tr:hover { background: #f8f9fa; }
.content-cell { max-width: 300px; word-break: break-word; }
.link-btn { color: #3498db; text-decoration: none; }
.link-btn:hover { text-decoration: underline; }
.status-tag { display: inline-block; padding: 4px 12px; border-radius: 4px; font-size: 12px; }
.status-tag.pending { background: #fff3cd; color: #856404; }
.status-tag.processed { background: #d4edda; color: #155724; }
.actions { display: flex; gap: 8px; }
.process-btn { padding: 6px 12px; background: #27ae60; color: white; border: none; border-radius: 5px; cursor: pointer; font-size: 12px; }
.done-text { color: #27ae60; font-size: 12px; }
.pagination { display: flex; justify-content: center; align-items: center; gap: 15px; margin-top: 20px; }
.pagination button { padding: 8px 15px; background: white; border: 1px solid #ddd; border-radius: 5px; cursor: pointer; }
.pagination button:disabled { opacity: 0.5; cursor: not-allowed; }
.total { margin-top: 10px; text-align: center; color: #666; }
</style>